/* eslint-disable react-hooks/exhaustive-deps */
import { SubKegiatanApi } from "api"
import Axios from "axios"
import {
  Alert,
  ApprovalStatusButton,
  CreateButton,
  CRUDLayout,
  DataStatus,
  FilterButton,
  InputSearch,
  Pagination,
  ReadButton,
  TBody,
  Td,
  TdFixed,
  Th,
  Tr,
  UpdateButton,
} from "components"
import Thead from "components/Table/THead"
import { useEffect, useState } from "react"
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom"
import { DateConvert, TableNumber } from "utilities"
import { ModalFilterKegiatan } from "./Comps"
import { ButtonGroup } from "react-bootstrap"

export const ListSubKegiatan = ({ setNavbarTitle }) => {
  // Title
  const title = "Sub Kegiatan"

  // STATE LOADING
  const [isLoading, setIsLoading] = useState(true)

  // STATE SEARCHING
  const [searchKey, setSearchKey] = useState("")

  // STATE DATA KELOMPOK
  const [data, setData] = useState([])

  const [dropdown, setDropdown] = useState({
    unitOrganisasi: [],
    penanggungJawab: [],
  })

  const history = useHistory()
  const location = useLocation()

  const [dataFilter, setDataFilter] = useState({
    filter: {
      active: false,
      tgl_program_start: undefined,
      tgl_program_end: undefined,
      tgl_kegiatan_start: undefined,
      tgl_kegiatan_end: undefined,
      tgl_sub_kegiatan_start: undefined,
      tgl_sub_kegiatan_end: undefined,
      id_unit_organisasi: undefined,
      id_penanggung_jawab_sub_kegiatan: undefined,
      status_approval_sub_kegiatan: undefined,
    },
    pagination: {
      page: "1",
      dataLength: "10",
      totalPage: "1",
      dataCount: "0",
    },
  })

  const [showModalFilter, setShowModalFilter] = useState(false)

  // KONFIGURASI ALERT
  const [alertConfig, setAlertConfig] = useState({
    variant: "primary",
    text: "",
    show: false,
  })

  const [searchTime, setSearchTime] = useState(null)

  // FUNCTION GET DATA DARI SERVER
  const getData = () => {
    setIsLoading(true)

    Axios.all([
      SubKegiatanApi.getPage({
        q: searchKey,
        page: dataFilter?.pagination?.page,
        per_page: dataFilter?.pagination?.dataLength,
        tgl_program_start: dataFilter?.filter?.tgl_program_start,
        tgl_program_end: dataFilter?.filter?.tgl_program_end,
        tgl_kegiatan_start: dataFilter?.filter?.tgl_kegiatan_start,
        tgl_kegiatan_end: dataFilter?.filter?.tgl_kegiatan_end,
        tgl_sub_kegiatan_start: dataFilter?.filter?.tgl_sub_kegiatan_start,
        tgl_sub_kegiatan_end: dataFilter?.filter?.tgl_sub_kegiatan_end,
        id_unit_organisasi: dataFilter?.filter?.id_unit_organisasi,
        id_penanggung_jawab_sub_kegiatan:
          dataFilter?.filter?.id_penanggung_jawab_sub_kegiatan,
        status_approval_sub_kegiatan:
          dataFilter?.filter?.status_approval_sub_kegiatan,
      }),
    ])
      .then(
        Axios.spread((res) => {
          setData(res?.data?.data?.data)

          setDataFilter({
            ...dataFilter,
            pagination: {
              ...dataFilter.pagination,
              dataCount: res?.data?.data?.data_count,
              totalPage: res?.data?.data?.total_page,
            },
          })
        })
      )
      .catch((err) => alert(err))
      .finally(() => {
        setIsLoading(false)
      })
  }

  // FUNCTION GET DATA DROPDOWN DARI SERVER
  const getDropdown = () => {
    Axios.all([
      SubKegiatanApi.dropdownUnitOrganisasi(),
      SubKegiatanApi.dropdownKaryawan(),
    ]).then(
      Axios.spread((unit, karyawan) => {
        const mappingDropdownUnitOrganisasi = (data) =>
          data.map((val) => ({
            label: val.nama_unit_organisasi,
            value: val.id_unit_organisasi,
          }))
        const mappingDropdownPenanggungJawab = (data) =>
          data.map((val) => ({
            label: val.nama_karyawan,
            value: val.id_karyawan,
          }))
        setDropdown({
          unitOrganisasi: mappingDropdownUnitOrganisasi(unit?.data?.data ?? []),
          penanggungJawab: mappingDropdownPenanggungJawab(
            karyawan?.data?.data ?? []
          ),
        })
      })
    )
  }

  const onInputSearch = (text) => {
    const key = text.target.value
    if (searchTime) clearTimeout(searchTime)
    setSearchTime(
      setTimeout(() => {
        setSearchKey(key)
        setAlertConfig({
          variant: "primary",
          text: `Hasil Pencarian : ${key}`,
          show: key === "" ? false : true,
        })
      }, 750)
    )
  }

  const checkAlert = () => {
    const locationState = location.state

    if (locationState) {
      if (locationState.alert) {
        setAlertConfig({
          show: locationState.alert.show,
          text: locationState.alert.text,
          variant: locationState.alert.variant,
        })
      }
    }
  }

  // ON COMPONENT MOUNT
  useEffect(() => {
    setNavbarTitle(title) // SET JUDUL NAVBAR
    getData() // GET DATA DARI SERVER
    getDropdown()
    checkAlert()

    return () => {
      setIsLoading(false)
    }
  }, [
    setNavbarTitle,
    dataFilter?.pagination?.page,
    dataFilter?.pagination?.dataLength,
    dataFilter?.filter?.active,
    dataFilter?.filter?.tgl_program_start,
    dataFilter?.filter?.tgl_program_end,
    dataFilter?.filter?.tgl_kegiatan_start,
    dataFilter?.filter?.tgl_kegiatan_end,
    dataFilter?.filter?.tgl_kegiatan_start,
    dataFilter?.filter?.tgl_kegiatan_end,
    dataFilter?.filter?.tgl_sub_kegiatan_start,
    dataFilter?.filter?.tgl_sub_kegiatan_end,
    dataFilter?.filter?.id_unit_organisasi,
    dataFilter?.filter?.id_penanggung_jawab_sub_kegiatan,
    dataFilter?.filter?.status_approval_sub_kegiatan,
    searchKey,
  ])

  // TABLE COMPONENT
  const Table = () => {
    const checkStatus = (stat) => {
      const data = stat ? stat.toUpperCase() : ""
      const convert = data.substring(0, 3)

      if (convert === "APP")
        return {
          variant: "outline-approved",
          label: "APPROVED",
        }
      // return "APPROVED";
      if (convert === "VER")
        return {
          variant: "outline-verified",
          label: "VERIFIED",
        }
      // return "VERIFIED";
      if (convert === "REV")
        return {
          variant: "outline-revised",
          label: "REVISION",
        }
      // return "REVISI";
      if (convert === "REJ")
        return {
          variant: "outline-danger",
          label: "REJECTED",
        }
      // return "REJECT";

      return {
        variant: "outline-pending",
        label: "PENDING",
      }
      // return "PENDING";
    }
    return (
      <>
        <CRUDLayout.Table>
          <Thead>
            <Tr>
              <Th>No.</Th>
              <Th>Aksi</Th>
              <Th>Informasi Sub Kegiatan</Th>
              <Th>Informasi Kegiatan</Th>
              <Th>Informasi Program</Th>
              <Th>Program</Th>
              <Th>Kegiatan</Th>
              <Th>Nama Sub Kegiatan</Th>
              <Th>Penanggung Jawab</Th>
              <Th>Lama Periode</Th>
              <Th>Status Approval</Th>
            </Tr>
          </Thead>
          <TBody>
            {data.length <= 0 ? (
              <Tr>
                <Td colSpan="11">
                  <DataStatus text="Tidak Ada Data" />
                </Td>
              </Tr>
            ) : (
              data.map((val, index) => {
                return (
                  <Tr key={val.id_sub_kegiatan}>
                    <Td className="text-center" width="20px">
                      {TableNumber(
                        dataFilter?.pagination?.page,
                        dataFilter?.pagination?.dataLength,
                        index
                      )}
                    </Td>
                    <TdFixed>
                      <div className="d-flex justify-content-center">
                        <ButtonGroup>
                          <ReadButton
                            size="sm"
                            onClick={() => {
                              history.push(
                                "/transaksi/sub-kegiatan/detail/" +
                                val.id_sub_kegiatan
                              )
                            }}
                          />
                          {checkStatus(val.status_approval_sub_kegiatan).label === "REVISION" && (
                              <UpdateButton
                                size="sm"
                                onClick={() => {
                                  history.push(
                                    "/transaksi/sub-kegiatan/ubah/" +
                                    val.id_sub_kegiatan
                                  )
                                }}
                              />
                            )}
                        </ButtonGroup>
                      </div>
                    </TdFixed>
                    <TdFixed>
                      <div>
                        {val.tgl_sub_kegiatan
                          ? DateConvert(new Date(val?.tgl_sub_kegiatan))
                            .defaultDMY
                          : "-"}
                      </div>
                      <div>{val.no_sub_kegiatan ?? ""}</div>
                    </TdFixed>
                    <TdFixed>
                      <div>
                        {val.tgl_kegiatan
                          ? DateConvert(new Date(val?.tgl_kegiatan)).defaultDMY
                          : "-"}
                      </div>
                      <div>{val.no_kegiatan ?? ""}</div>
                    </TdFixed>
                    <TdFixed>
                      <div>
                        {val.tgl_program
                          ? DateConvert(new Date(val?.tgl_program)).defaultDMY
                          : "-"}
                      </div>
                      <div>{val.no_program ?? ""}</div>
                    </TdFixed>
                    <Td>{val.nama_program ?? "-"}</Td>
                    <Td>{val.nama_kegiatan ?? "-"}</Td>
                    <Td>{val.nama_sub_kegiatan ?? "-"}</Td>
                    <Td>{val.nama_penanggung_jawab_sub_kegiatan ?? "-"}</Td>
                    <Td>{`${val.lama_periode_sub_kegiatan ?? "-"} Hari`}</Td>
                    <TdFixed>
                      <ApprovalStatusButton
                        variant={
                          checkStatus(val.status_approval_sub_kegiatan).variant
                        }
                      >
                        {checkStatus(val.status_approval_sub_kegiatan).label}
                      </ApprovalStatusButton>
                    </TdFixed>
                  </Tr>
                )
              })
            )}
          </TBody>
        </CRUDLayout.Table>
        {data.length > 0 && (
          <Pagination
            dataLength={dataFilter?.pagination?.dataLength}
            dataNumber={
              dataFilter?.pagination?.page *
              dataFilter?.pagination?.dataLength -
              dataFilter?.pagination?.dataLength +
              1
            }
            dataPage={
              dataFilter?.pagination?.dataCount <
                dataFilter?.pagination?.dataLength
                ? dataFilter?.pagination?.dataCount
                : dataFilter?.pagination?.page *
                dataFilter?.pagination?.dataLength
            }
            dataCount={dataFilter?.pagination?.dataCount}
            currentPage={dataFilter?.pagination?.page}
            totalPage={dataFilter?.pagination?.totalPage}
            onPaginationChange={({ selected }) =>
              setDataFilter({
                ...dataFilter,
                pagination: {
                  ...dataFilter.pagination,
                  page: selected + 1,
                },
              })
            }
            onDataLengthChange={(e) =>
              setDataFilter({
                ...dataFilter,
                pagination: {
                  ...dataFilter.pagination,
                  page: 1,
                  dataLength: e.target.value,
                },
              })
            }
          />
        )}
      </>
    )
  }

  console.log(showModalFilter)
  return (
    <>
      <CRUDLayout>
        <CRUDLayout.Head>
          <CRUDLayout.HeadSearchSection>
            <div className="d-flex mb-3">
              <InputSearch
                onChange={(e) => {
                  onInputSearch(e)
                }}
              />
              <FilterButton
                active={dataFilter?.filter?.active}
                onClick={() => setShowModalFilter(true)}
              />
            </div>
          </CRUDLayout.HeadSearchSection>

          {/* Button Section */}
          <CRUDLayout.HeadButtonSection>
            <CreateButton
              onClick={() => history.push("sub-kegiatan/kegiatan")}
            />
          </CRUDLayout.HeadButtonSection>
        </CRUDLayout.Head>
        {/* Alert */}
        <Alert
          show={alertConfig.show}
          showCloseButton={true}
          variant={alertConfig.variant}
          text={alertConfig.text}
          onClose={() => setAlertConfig({ ...alertConfig, show: false })}
        />
        {isLoading ? (
          <DataStatus loading={isLoading} text="Memuat Data" />
        ) : (
          <>
            <b>List Data Sub Kegiatan</b>
            <Table />
          </>
        )}
        {showModalFilter && (
          <ModalFilterKegiatan
            show={showModalFilter}
            setShow={setShowModalFilter}
            data={dataFilter}
            setData={setDataFilter}
            dropdown={dropdown}
          />
        )}
      </CRUDLayout>
    </>
  )
}
